export default "__VITE_ASSET__D3PSj9Wb__"